
import vClickOutside from 'v-click-outside'
export default {
  name: 'DropdownSelector',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    showModal: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: String,
      default: '',
    },

    options: {
      type: Array,
      default() {
        return []
      },
    },

    variant: {
      type: String,
      default: 'outline-secondary',
    },
  },

  data() {
    return {
      temp_Object: '',
      show_modal: false,
      temp_input: '',
      input: this.$route.query.rank ? this.$route.query.rank : process.env.ALGOLIA_INDEX,
      selected_txt: '',
    }
  },

  watch: {
    input(val) {
      if (this.$device.isDesktop) {
        this.selected_txt = this.$t(`search.sort.${val}`)
        this.$emit('change', val)
      }
    },
  },

  beforeMount() {
    this.$nextTick(() => {
      this.selected_txt = this.$t(`search.sort.${this.input}`)
    })
  },

  mounted() {
    this.dropdownListner()
  },
  methods: {
    dropdownListner() {
      this.$root.$on('bv::dropdown::show', () => {
        if (!this.$device.isDesktop) {
          this.show_modal = true
          this.temp_input = this.input
          this.$nuxt.$emit('ja-backdrop', true)
        }
      })
      this.$root.$on('bv::dropdown::hide', () => {
        if (!this.$device.isDesktop) {
          this.show_modal = false
          this.$nuxt.$emit('ja-backdrop', false) //destroy backdrop
        }
      })
    },

    close() {
      this.input = this.temp_input
      this.temp_input = ''
      //this.show_modal = false
      this.$refs.dropdown.hide()
      this.$nuxt.$emit('ja-backdrop', false) //destroy backdrop
    },

    submit() {
      this.$emit('change', this.input)
      this.selected_txt = this.$t(`search.sort.${this.input}`)
    },
  },
}
